import { Injectable, Injector } from '@angular/core';
import { get, merge } from 'lodash';

import {
  BackendApiType,
  ENTITY_TYPES,
  IApiListResponse,
  IBaseEntityType,
  IDocumentOperationOptions,
  IEntityConfig,
  IFilterQuery,
} from '@app/shared/types';

import { BaseService } from '../base';
import { HttpParams } from '@angular/common/http';
import { MAX_PAGE_SIZE } from '@config/global-constants';
import { Observable, rx } from '@app/shared/rx';

const entityType: ENTITY_TYPES = ENTITY_TYPES.EVENTS;
const config: IEntityConfig = {
  backendApiType: BackendApiType.PORTAL,
  ENTITY_TYPE: entityType,
  entityIdPath: '_id',
  isMasterListAvailable: true,
  apiEndpoint: entityType,
  uiRoute: entityType,
  buttons: {},
};

@Injectable()
export class EventsService extends BaseService {
  public static config: IEntityConfig = config;
  public static ENTITY_TYPE: string = config.ENTITY_TYPE;
  public entityPath: string = 'id';

  public constructor(public injector: Injector) {
    super(injector);
  }

  public getItemValue(item: IBaseEntityType): string {
    return get(item, this.entityPath, '');
  }

  public fetchList(
    userQuery?: IFilterQuery,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    options?: IDocumentOperationOptions,
  ): Observable<IApiListResponse> {
    return this.companyService.currentCompanyId$.pipe(
      rx.filter((companyId) => !!companyId),
      rx.switchMap((companyId) => {
        const basicPath = `v1/companies/${companyId}/events`;
        const query: IFilterQuery = merge({}, this.defaultQuery, userQuery);
        const params: HttpParams = this.createParams({
          top: MAX_PAGE_SIZE,
          ...query,
        });

        return this.http
          .get(basicPath, { params })
          .pipe(this.catchHttpError()) as Observable<IApiListResponse>;
      }),
    );
  }
}
